var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarningKoalafi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.18216 14.6788L7.96893 1.84875C8.1045 1.59253 8.30735 1.37812 8.55567 1.22857C8.80398 1.07902 9.08837 1 9.37824 1C9.66811 1 9.9525 1.07902 10.2008 1.22857C10.4491 1.37812 10.652 1.59253 10.7876 1.84875L17.5743 14.6788C17.7017 14.9209 17.7642 15.1919 17.7557 15.4654C17.7472 15.7388 17.6681 16.0054 17.5259 16.2392C17.3838 16.4729 17.1835 16.6659 16.9446 16.7992C16.7057 16.9325 16.4363 17.0017 16.1627 17H2.5907C2.31738 17.0012 2.0484 16.9316 1.80992 16.7981C1.57144 16.6645 1.37159 16.4715 1.22979 16.2378C1.088 16.0042 1.00909 15.7378 1.00074 15.4646C0.992391 15.1914 1.05489 14.9207 1.18216 14.6788V14.6788Z",
    stroke: "#0D4066",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.37695 6.33496V10.9057",
    stroke: "#0D4066",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.37706 14.7141C10.0081 14.7141 10.5197 14.2025 10.5197 13.5714C10.5197 12.9403 10.0081 12.4287 9.37706 12.4287C8.74597 12.4287 8.23438 12.9403 8.23438 13.5714C8.23438 14.2025 8.74597 14.7141 9.37706 14.7141Z",
    fill: "#0D4066"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningKoalafi);
export default __webpack_public_path__ + "static/media/warning-koalafi.6029fccf6d61439d47a4343ea4c7db37.svg";
export { ForwardRef as ReactComponent };